module.exports = __webpack_public_path__ + "img/wuLong6.b065a8e7.png";